import { connect } from 'react-redux';
import { compose } from 'redux';

import { setPopover } from '../../actions/login';
import { signalLogout } from '../../actions/tokens';
import AccountMenu from './AccountMenu';

const Container = (props) => <AccountMenu {...props} />;

const mapStateToProps = ({ login }) => ({
  isLoggedIn: login.isLoggedIn,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => {
    dispatch(setPopover(false));
    dispatch(signalLogout());
  },
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Container);
